import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {DataObjectId, Hub} from 'yougile-model'
import {Sync} from '@client/sync'
import {UserSettings} from '@client/user-settings'
import {TaskChatQuickLinkList} from '@components/chat/chat-header/task-chat-quick-link-list'
import {Avatar} from '@components/common/base/avatar'
import {IconButton} from '@components/common/base/buttons'
import {useTaskFromHubWithStarredEffect} from '@components/my-tasks/task-item'
import {createEnhancedWithSyncedPersonalChat} from '@containers/enhanced-with-personal-chat/enhanced-with-synced-personal-chat'
import {cn} from '@containers/html-utils'
import {PersonalChatProxy} from '@extensions/proxies/personal-chat-proxy'
import {ChatNav} from './chat-nav'

const TwPersonalChatHeader = tw.div`
  pb-12
  px-24
  flex
  gap-8
  shadow-border-b-1
  shadow-grey-l60
`

const TwContent = tw.div`
  min-w-0
  flex
  flex-col
  gap-8
`

const TwUserName = tw.div`
  min-w-0
  font-semibold
  text-18
  leading-6
  text-primary
  break-words
`

const TwMessage = tw.div`
  plain-text-regular
  text-placeholder
`

const TwMessageUserName = tw.span`
  break-words
`

interface Props extends PersonalChatProxy {
  readonly companyId: DataObjectId
}

const PersonalChatHeaderBase = ({
  userId,
  chatId,
  companyId,
  userName
}: Props) => {
  const box = Sync.getProfile()
  const hub = box.get(chatId) as Hub

  const hubStarred = useTaskFromHubWithStarredEffect(hub)

  const toggleStar = () => {
    UserSettings.setStarred(hubStarred, !hubStarred?.starred, 'personal')
  }

  return (
    <>
      <ChatNav />
      <TwPersonalChatHeader>
        <Avatar
          size={48}
          userId={userId}
          hideHint
          hideOutline
          className="flex-none"
        />
        <TwContent>
          <TwUserName>{userName}</TwUserName>
          <TwMessage>
            {Lang.msg.directChatVisibleOnly}{' '}
            <TwMessageUserName>{userName}</TwMessageUserName>
          </TwMessage>
        </TwContent>
        <IconButton
          icon={hubStarred?.starred ? 'IconStarFilled' : 'IconStar'}
          color="secondary"
          size="small"
          wrapperSize="big"
          className={cn(
            'ml-auto',
            hubStarred?.starred && '!text-marker hover:!text-marker-l20'
          )}
          onClick={toggleStar}
          content={Lang.msg.taskPage.starHintGroupChat}
        />
      </TwPersonalChatHeader>
      <TaskChatQuickLinkList chatId={chatId} companyId={companyId} />
    </>
  )
}

export const PersonalChatHeader = createEnhancedWithSyncedPersonalChat(
  PersonalChatHeaderBase
)
